var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 11.0799V11.9999C22.4988 14.1563 21.8005 16.2545 20.5093 17.9817C19.2182 19.7088 17.4033 20.9723 15.3354 21.5838C13.2674 22.1952 11.0573 22.1218 9.03447 21.3744C7.01168 20.6271 5.28465 19.246 4.11096 17.4369C2.93727 15.6279 2.37979 13.4879 2.52168 11.3362C2.66356 9.18443 3.49721 7.13619 4.89828 5.49694C6.29935 3.85768 8.19279 2.71525 10.2962 2.24001C12.3996 1.76477 14.6003 1.9822 16.57 2.85986",
    stroke: "#12A132",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5 4L12.5 14.01L9.5 11.01",
    stroke: "#12A132",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPass);
export default __webpack_public_path__ + "static/media/icon_pass.792698e7d93565f82927e8872b06a102.svg";
export { ForwardRef as ReactComponent };